const translations = {
  "en": {
    "Trending Themes": "Trending Themes"
  },
  "zh-tw": {
    "Trending Themes": "熱門主題"
  }
};

export default translations;
